import CV from '../../assets/pdf/CV_2025-02-07_Valentin_CADART.pdf';

const pdfs = { CV };

export default pdfs;